<ng-container *notInProductCode="productCode.Partners">
  <div class="full-page-container">
    <div class="d-lg-block d-none">
      <fgb-banner [title]="'challenges.page.title' | translate"></fgb-banner>
    </div>

    <fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'"></fgb-page-header>

    <div class="container">
      <fgbcl-badge-achieved />
    </div>

    <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
  </div>
</ng-container>

<ng-container *inProductCode="productCode.Partners">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
